import {gql} from '@apollo/client'

export const GET_PDF_PRESCRIPTION = gql`
  query getDoctorPrescription($doctorId: ID!) {
    getDoctorPrescription(doctorId: $doctorId) {
      id
      formKeyValues {
        doctorName
        doctorQualification
        showDoctorQualification
        doctorSpeciality
        showSpeciality
        phoneNo
        showPhoneNo
        businessNo
        showBusinessNo
        email
        showEmail
        address
        showAddress
        hospitalName
        showHospital
        websiteUrl
        showWebsite
        showMciNumber
        headerContent
        footerContent
        headerImage
        headerHeight
        footerHeight
      }
      templateName
      doctorId
      image
      createdDate
      clinicLogo
      doctorSignature
      mciNumber
      createdBy
    }
  }
`

export const SET_PDF_PRESCRIPTION = gql`
  mutation setDoctorPrescriptionData(
    $doctorId: ID!
    $formKeyValues: formKeyValuesInput
    $doctorSignature: String
    $clinicLogo: String
  ) {
    setDoctorPrescriptionData(
      prescriptionInput: {
        doctorId: $doctorId
        formKeyValues: $formKeyValues
        doctorSignature: $doctorSignature
        clinicLogo: $clinicLogo
      }
    )
  }
`

export const CHANGE_PRESCRIPTION = gql`
  mutation changePrescriptionTemplate($doctorId: ID!, $templateName: String!) {
    changePrescriptionTemplate(doctorId: $doctorId, templateName: $templateName)
  }
`
